import Duck from 'extensible-duck';
import axios from 'axios';
import uuid from 'uuid';

import { DUCKS_NAMESPACE } from '../config/constants';

const mapVirtualTransactionsToWallets = ({
  wallets,
  virtualTransactions,
  offset,
}) => {
  const numberOfVirtualTransactions = offset + virtualTransactions.length;
  const walletsByReference = {};
  wallets.forEach((wallet, index) => {
    if (offset === 0) {
      wallet.virtualTransactions = [];
      wallet.displayColumn = index;
    }
    walletsByReference[wallet.externalReferenceId] = wallet;
  });
  console.log('Inspecting virtual tx ', virtualTransactions);
  virtualTransactions.forEach((virtualTransaction, index) => {
    const sourceWallet =
      walletsByReference[virtualTransaction.sourceWalletReferenceId];
    virtualTransaction.displayRow = offset + index;
    virtualTransaction.targetWalletDisplayColumn =
      walletsByReference[
        virtualTransaction.targetWalletReferenceId
      ].displayColumn;
    sourceWallet.virtualTransactions.push(virtualTransaction);
  });

  return { wallets, numberOfVirtualTransactions };
};

export default new Duck({
  namespace: DUCKS_NAMESPACE,
  store: 'wallets',
  initialState: {
    isPending: false,
    isError: false,
    wallets: [],
  },

  types: [
    'LOAD_WALLETS',
    'LOAD_WALLETS_PENDING',
    'LOAD_WALLETS_FULFILLED',
    'LOAD_WALLETS_REJECTED',
    'CREATE_WALLET',
    'CREATE_WALLET_PENDING',
    'CREATE_WALLET_FULFILLED',
    'CREATE_WALLET_REJECTED',
    'ADD_VIRTUAL_TRANSACTIONS',
    'DELETE_VIRTUAL_TRANSACTIONS',
    'DELETE_VIRTUAL_TRANSACTIONS_PENDING',
    'DELETE_VIRTUAL_TRANSACTIONS_FULFILLED',
    'DELETE_VIRTUAL_TRANSACTIONS_REJECTED',
  ],

  reducer: (state, action, { types, initialState }) => {
    switch (action.type) {
      // Load wallets
      case types.LOAD_WALLETS_PENDING:
        return { ...state, isPending: true };
      case types.LOAD_WALLETS_FULFILLED:
        return {
          ...state,
          ...action.payload,
          isPending: false,
          isError: false,
        };
      case types.LOAD_WALLETS_REJECTED:
        return { ...state, isPending: false, isError: true };
      // Create wallet
      case types.CREATE_WALLET_PENDING:
        return { ...state, isPending: true };
      case types.CREATE_WALLET_FULFILLED:
        return {
          ...state,
          wallets: [...state.wallets, action.payload],
          isPending: false,
          isError: false,
        };
      case types.CREATE_WALLET_REJECTED:
        return { ...state, isPending: false, isError: true };
      // Virtual transactions
      case types.ADD_VIRTUAL_TRANSACTIONS:
        return {
          ...state,
          wallets: action.payload.wallets,
          numberOfVirtualTransactions:
            action.payload.numberOfVirtualTransactions,
        };
      case types.DELETE_VIRTUAL_TRANSACTIONS_FULFILLED:
        return { ...state, ...action.payload };
      default:
        return state;
    }
  },

  creators: ({ types }) => ({
    loadWallets: (token) => ({
      type: types.LOAD_WALLETS,
      payload: Promise.all([
        axios
          .request('/api/v2/demowallet/admin/wallet/tx/virtual/wallets', {
            headers: {
              'Api-Key': token,
            },
          })
          .then(({ data: result }) => {
            return result.data;
          }),
        axios
          .request(
            '/api/v2/demowallet/admin/wallet/tx/virtual?statusList=Success%7CFailure%7CPending&startWith=0&count=500&sorting=%2BCreationDateTime',
            {
              headers: {
                'Api-Key': token,
              },
            },
          )
          .then(({ data: result }) => {
            return result.data;
          }),
      ]).then((values) => {
        return mapVirtualTransactionsToWallets({
          wallets: values[0],
          virtualTransactions: values[1],
          offset: 0,
        });
      }),
    }),
    createWallet: (token, externalReferenceId) => (dispatch, getState) => {
      const numberOfWallets = getState().wallets.wallets.length;
      return dispatch({
        type: types.CREATE_WALLET,
        payload: axios
          .post(
            '/api/v2/demowallet/admin/wallet/tx/virtual/wallets',
            {
              emailAddress:
                'catchall+virtualwallet-' + +new Date() + '@trimplement.com',
              password: uuid.v4(),
              countryCode: 'DE',
              externalReferenceId,
              description: 'Virtual Wallet',
            },
            {
              headers: {
                'Api-Key': token,
              },
            },
          )
          .then(({ data: result }) => {
            const wallet = result.data;
            wallet.virtualTransactions = [];
            wallet.displayColumn = numberOfWallets;
            return wallet;
          }),
      });
    },
    startClearing: ({ token }) => ({
      type: types.START_CLEARING,
      payload: axios
        .post(
          '/api/v2/demowallet/admin/wallet/tx/virtual/clearing',
          {},
          {
            headers: {
              'Api-Key': token,
            },
          },
        )
        .then(({ data: result }) => {
          return result.data;
        }),
    }),
    addVirtualTransactions:
      ({ virtualTransactions }) =>
      (dispatch, getState) => {
        const { wallets, numberOfVirtualTransactions } = getState().wallets;
        const result = mapVirtualTransactionsToWallets({
          wallets,
          virtualTransactions,
          offset: numberOfVirtualTransactions,
        });
        return dispatch({
          type: types.ADD_VIRTUAL_TRANSACTIONS,
          payload: {
            wallets: result.wallets,
            numberOfVirtualTransactions:
              numberOfVirtualTransactions + virtualTransactions.length,
          },
        });
      },
    deleteVirtualTransactions:
      ({ token }) =>
      (dispatch, getState) => {
        return dispatch({
          type: types.DELETE_VIRTUAL_TRANSACTIONS,
          payload: axios
            .delete('/api/v2/demowallet/admin/wallet/tx/virtual', {
              headers: {
                'Api-Key': token,
              },
            })
            .then(() => {
              const { wallets } = getState().wallets;
              wallets.forEach((wallet) => {
                wallet.virtualTransactions = [];
              });
              return {
                wallets,
                numberOfVirtualTransactions: 0,
              };
            }),
        });
      },
  }),
});
